import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'

export function createBtnLabel(label: string | undefined, array: unknown[], fallback?: string) {
  // return label name with... if there is more than one selected Item

  if (!label) return fallback

  if (array.length > 1) {
    label = `${label} + ${array.length - 1}`
  }
  return label
}

export function getPureProperties(properties: PopoverProperty[]) {
  return properties.filter(
    p => p.label !== 'all ' && p.label !== 'select-all ' && p.label !== 'separator',
  )
}
